import Modal from '@src/common/Modal';
import  {useEffect, useState} from 'react';
import moment from 'moment'
import {  Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getQuotationList } from '@store/slices/commonId';
import { useDispatch } from 'react-redux';
import { addCurrencyFormatting, roundPercent } from '@src/config/helper';
import CommonServiceId from '@src/services/CommonServiceId';
import { LEAD_STATUS, QUOTE_EXPIRED_DAYS, QUOTED_EXPIRE_STATUS, WHATSAPP_WEB_URL } from '@src/config/id/constant';
import { useLanguage } from "@src/context/LanguageContext";
import secureStorage from '@src/config/encrypt';
import { toast } from "react-toastify";


const ShowQuotationID = (props: any) => {
  let { show, handleClose, leadDetail, screenType,setLoading } = props;

  const dispatch:any = useDispatch();
  const navigate = useNavigate();
  
  const [data,setData] = useState<any>([]);
  const [activeCompany, setActiveCompany] = useState<string>('');
  const [activeQuote, setActiveQuote] = useState<number>(0);
  const selectedCompany = data?.find((c: any) => c.name === activeCompany);
  const selectedQuote = selectedCompany?.items?.[activeQuote];
  const {translations} = useLanguage();

  const downloadFile = (file: string) => {
    if (checkQuoteExpired()) {
      secureStorage.setItem('lead_id', leadDetail?.leadId);
      secureStorage.setItem('goToQuote', 'true');
      handleClose();
      navigate('/create-insurance-policy?step=vehicle');
      return;
    }
    window.open(file, "_blank");
  };

  const getQuotationData = async () => {
    try{
      setLoading(true);
      const quote = await dispatch(getQuotationList({lead_id:leadDetail?.leadId}));
      if(quote.status === 200) {
        setData(quote.data);
        setActiveCompany(quote.data?.[0]?.name || '');
      }

    }catch(e){
      console.log(e);

    }finally{
      setLoading(false);
    }
  }
  useEffect(() => {
    getQuotationData();
    
  }, [])

     const shareQuotation = async () => {
         try {

          if (checkQuoteExpired()) {
            secureStorage.setItem('lead_id', leadDetail?.leadId);
            secureStorage.setItem('goToQuote', 'true');
            handleClose();
            navigate('/create-insurance-policy?step=vehicle');
            return;
          }

          if (!selectedQuote?.pdf_path) {
            toast.error("Quotation PDF is not ready yet. Please try sharing again in a moment.");
            return;
          }

          setLoading(true);
           let path = await CommonServiceId.getShortFileUrl({url:selectedQuote?.pdf_path})
           path = path?.data?.data
           if (!path || typeof path !== 'string') {
            toast.error("Quotation PDF is not ready yet. Please try sharing again in a moment.");
            return;
           }
           const message = `Hello, please check this document: ${path}`;
           const url = WHATSAPP_WEB_URL + encodeURIComponent(message);
           window.open(url, '_blank', 'noreferrer');

         } catch (error) {
          console.log(error);
          
         }finally{
          setLoading(false);
         }
      }
    
   useEffect(() => {
          if (show) document.body.classList.add("overflow-hidden");
          return () => {
              document.body.classList.remove("overflow-hidden");
          }
      }, [show])  
      
  const checkQuoteExpired = () => {
    const statusId = +leadDetail?.status_id || +leadDetail?.status;
    const subStatusId = +leadDetail?.sub_status_id || +leadDetail?.sub_status;
    const isQuoteShare = statusId === LEAD_STATUS.quotation_shared.status_id && subStatusId === LEAD_STATUS.quotation_shared.sub_status_id;
    if(+selectedQuote.quotation_expired===QUOTED_EXPIRE_STATUS.EXPIRED && isQuoteShare){
      return true
    }else{
      return false
    }
  }   

  return (
    <div className="model-outer upload-error-popup quotation-modal">
      <Modal show={show} handleClose={handleClose}>
        <div className="payment-info-modal-body">
          <div className='modal-header show-quotation-heading'>

          {/* Header */}
          <h2>
            {screenType}
          </h2>
          <p className="payment-info-description text-center mb-4">
           {leadDetail.make_name} {leadDetail.model_name} {leadDetail.version_name}  {leadDetail.plate_number}
          </p>

</div>
<div className='modal-body'>
          
          {selectedCompany &&
            <>      
          <Nav
            variant="pills"
            className="flex-column tab-line nav nav-pills tabs-insure"
            activeKey={activeCompany}
            onSelect={(k: string | null) => {
              if (k) setActiveCompany(k);
              setActiveQuote(0);
            }}
          >
            <div className="tab-list d-flex justify-content-center">
              {data?.map((company: any, index: any) => (
                <Nav.Item key={index}>
                  <Nav.Link eventKey={company.name}>
                    {`${company.name} (${company.items?.length})`}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </div>
          </Nav>
           </>
          }

          {selectedCompany?.items?.length > 1 && (
            <Nav
              variant="pills"
              className="flex-column nav nav-pills mt-3 w-100 tab-btn-quote"
              activeKey={activeQuote}
              onSelect={(k: any) => setActiveQuote(k)}
            >
              <div className="tab-list d-flex justify-content-center">
                {selectedCompany?.items?.map((quote: any, index: number) => (
                  <Nav.Item key={index}>
                    <Nav.Link eventKey={index}>
                      Quote {selectedCompany?.items?.length - index}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </div>
            </Nav>
          )}

          {/* Quotation title */}
          <div className="payment-info-row br-bottom-none">
            <div>
              <h3 className="payment-info-subheader mb-1">
                {activeCompany}
              </h3>
              <small className="payment-info-description">
                {leadDetail?.created_on
    ? moment(selectedQuote?.created_at).format('DD MMM YYYY, hh:mm A')
    : "-"}
              </small>
            </div>
              {
                selectedQuote?.pdf_path?.length &&
                <button className="download-btn" onClick={() => downloadFile(selectedQuote?.pdf_path)}><i className="ic-save_alt"></i></button>
              }     
          </div>

      
          {/* Details */}
          <div className="payment-info-row">
            <span className="payment-info-label"> {translations?.CREATE_APP?.INSURANCE_COMPANY}</span>
            <span className="payment-info-value">{selectedCompany?.name}</span>
          </div>

          <div className="payment-info-row">
            <span className="payment-info-label"> {translations?.CREATE_APP?.ESTIMATED_TSI}</span>
            <span className="payment-info-value">{addCurrencyFormatting(selectedQuote?.car_fmv)}</span>
          </div>

          <div className="payment-info-row">
            <span className="payment-info-label">{translations?.CREATE_APP?.PRICE_OF_ACC}</span>
            <span className="payment-info-value">{addCurrencyFormatting(selectedQuote?.acc_price || 0)}</span>
          </div>

          <div className="payment-info-row br-bottom-none">
            <span className="payment-info-label">{translations?.CREATE_APP?.OVERALL_CAR_PRICE} </span>
            <span className="payment-info-value">{addCurrencyFormatting(selectedQuote?.total_fmv)}</span>
          </div>

          <div className='fq-wave-divider '></div>

          <div className="payment-info-row">
            <span className="payment-info-label">{translations?.CREATE_APP?.BASIC_PREMIUM} </span>
            <span className="payment-info-value">{addCurrencyFormatting(selectedQuote?.basic_premium_amount)}</span>
          </div>

          <div className="payment-info-row">
            <span className="payment-info-label">
              {translations?.TASK_SUMMARY?.TOTAL_ADDONS} ⌄
            </span>
            <span className="payment-info-value">{addCurrencyFormatting(selectedQuote?.total_addon_amount)}</span>
          </div>

          <div className="payment-info-row">
            <span className="payment-info-label"> {translations?.CREATE_APP?.ADMIN_FEE} </span>
            <span className="payment-info-value">{addCurrencyFormatting(selectedQuote?.admin_fee)}</span>
          </div>

          <div className="payment-info-row ">
            <span className="payment-info-label"> {translations?.TASK_SUMMARY?.DISCOUNT_CUSTOMER} </span>
            <span className="payment-info-value">
              {roundPercent(selectedQuote?.customer_discount_per)}% / {addCurrencyFormatting(selectedQuote?.customer_discount)}
            </span>
          </div>

         

          {/* Total */}
          <div className="payment-info-row total-premium-txt">
            <span className="payment-info-label fw-bold">
              {translations?.CREATE_APP?.TOTAL_PREMIUM}
            </span>
            <span className="payment-info-value fw-bold">
              {addCurrencyFormatting(selectedQuote?.final_premium)}
            </span>
          </div>

   
       

        </div>

           <div className="modal-footer">
            {/* <button className="payment-info-secondary">
              🔗
            </button> */}

            <button className="btn btn-primary w-100 ms-3" onClick={shareQuotation}>
             {translations?.COMMON_MSG?.SHARE} 
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ShowQuotationID;
